import eventBus from "infrastructure/common/eventBus";
import {LoadingEvents} from "../components/style-guide/loading/LoadingEvents";

export const LoadingHelper = class {
  static open() {
    eventBus.dispatch(LoadingEvents.OPEN);
  }

  static close() {
    eventBus.dispatch(LoadingEvents.CLOSE);
  }
};
